export default __webpack_public_path__ + "static/media/battlementC.ce0bf02b.svg";